<div class="ratePop">
    <img
    src="assets/imgs/carlosbackground.jpeg"
  />
</div>